import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const CustomButton = styled(Button)`
  text-align: center;
  width: 100%;
  max-width: 49%;
  font-size: 13px;

  @media (max-width: ${({ theme }) => theme.screen.xsMin}) {
    padding:0;
  }

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    max-width: 180px;
  }

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    line-height: 48px;
    font-size: 16px;
    max-width: 191px;
  }
`
